import real from "./allocatorReal.json";

/* Allocator mockups: real N-PORT-based fields from allocatorReal.json (grades, active share, overlap);
   expense ratios are approximate public figures; decomposition / alerts are SAMPLE. */

export const REAL = real;
export const OBS = real.obs_date;
export const ER = {
  AGTHX: 0.59, FCNTX: 0.39, ANCFX: 0.57, FDGRX: 0.79, VWUSX: 0.36, FBGRX: 0.69, TRBCX: 0.69, AMCPX: 0.64,
  VPMCX: 0.38, DODGX: 0.51, OAKMX: 0.89, PRBLX: 0.82, MFEGX: 0.86, PRGFX: 0.65, FMAGX: 0.53, JENSX: 0.85, PRWCX: 0.70,
};
export const INDEX_FEE = 0.03;
export const SHORT = {
  AGTHX: "Growth Fund of America", FCNTX: "Fidelity Contrafund", ANCFX: "Fundamental Investors", FDGRX: "Fidelity Growth Co",
  VWUSX: "Vanguard US Growth", FBGRX: "Fidelity Blue Chip Growth", TRBCX: "T. Rowe Blue Chip Growth", AMCPX: "AMCAP",
  VPMCX: "Vanguard PRIMECAP", DODGX: "Dodge & Cox Stock", OAKMX: "Oakmark Fund", PRBLX: "Parnassus Core Equity",
  MFEGX: "MFS Growth", PRGFX: "T. Rowe Growth Stock", FMAGX: "Fidelity Magellan", JENSX: "Jensen Quality Growth",
  PRWCX: "T. Rowe Capital Appreciation",
};

export const funds = () => Object.values(real.grades).map(({ style, ...g }) => {
  const as = g.active_share;
  const er = ER[g.fund];
  return {
    ...g, er, fundStyle: style, short: SHORT[g.fund] || g.name,
    indexLike: g.ungraded_reason === "index_like",
    aer: (er - (1 - as) * INDEX_FEE) / as,
  };
});

export const effectiveManagers = () => {
  const L = real.lineup;
  const pairs = [];
  L.forEach((a, i) => L.slice(i + 1).forEach((b) => pairs.push(real.overlap[a][b] / 100)));
  const rho = pairs.reduce((s, x) => s + x, 0) / pairs.length;
  return { rho, eff: L.length / (1 + (L.length - 1) * rho) };
};

export const GRADE_EVIDENCE = "Positioning grade (peer-z of weight in names ≥3 elite specialists converge on): top vs bottom peer tercile +2.7% / 6M sector-adjusted (t 4.56, 89% of months positive); large-cap +3.3% (t 4.28); not used for small caps (no edge).";

export const DECOMP = [
  { k: "Market beta", v: 0.3 }, { k: "Growth / momentum tilt", v: 1.4 }, { k: "Size tilt", v: -0.2 }, { k: "Stock selection", v: 0.6 },
];
export const SECTOR_SEL = [
  { s: "Technology", hit: 61, w: 38 }, { s: "Health care", hit: 58, w: 12 }, { s: "Financials", hit: 55, w: 9 },
  { s: "Industrials", hit: 52, w: 8 }, { s: "Communication", hit: 49, w: 11 }, { s: "Consumer disc.", hit: 44, w: 14 },
];
export const QTR_SEL = [0.4, -0.3, 0.9, 0.2, -0.5, 0.7, 0.3, -0.2, 0.6, 0.1, -0.4, 0.8];

export const TILTS = [
  { f: "Beta", v: 0.12 }, { f: "Momentum", v: 0.48 }, { f: "Growth", v: 0.61 }, { f: "Size (large)", v: 0.35 },
  { f: "Quality", v: 0.18 }, { f: "Value", v: -0.52 }, { f: "Low volatility", v: -0.21 },
];
